import { InjectionToken } from '@angular/core';
import { GlobalSettings } from 'src/app/global-settings/global-settings.service';
import { FormConfig } from '../../model/form-config.interface';
import { DB_CLN_SETTINGS, DEFAULT_CLN_SETTINGS } from '../../model/product-settings/cln.settings';
import { COUPON_EVENT } from '../consts/coupon-event.const';
import { UNDERLYING_ASSETS_MODAL } from '../consts/underlying-assets-modal.const';
import { getDBForm } from './db-product-capture.const';

export const DB_FORM_CONFIG = new InjectionToken<FormConfig>('dbFormConfig');

export function dbFormConfigFactory(): FormConfig {
    const { userPreferences } = GlobalSettings.getAppSettings();
    const { emulateDBEnviroment } = userPreferences.userSettings || {};
    const clnSettings = emulateDBEnviroment ? DB_CLN_SETTINGS : DEFAULT_CLN_SETTINGS;

    return {
      client: {
        id: 1,
        name: 'Deutsch Bank',
      },
      forms: [
        { ...getDBForm(clnSettings) },
        { ...UNDERLYING_ASSETS_MODAL },
        { ...COUPON_EVENT },
      ],
    };

};